module.exports = __webpack_public_path__ + "img/icon-professional-profile.e86fa597.svg";